
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { ChangeAlertCallbackType } from '../../components/Root';
import * as API from '../../http/api';
import { getPosition } from '../../services/PositionService';

export type CatalogType = 'card_customization' | 'abb_status_lead'
export type ItemType = {
    value: any,
    name: string,
    metadata?: any
}
const formatData = (data?: any): ItemType[] => {
    const formattedData = data?.map((item: any) => ({
        value: item.k,
        name: item.v,
        metadata: item?.m[0]
    }));
    return formattedData;
};

export const useCatalog = (catalog: CatalogType, callbackChangeAlert: ChangeAlertCallbackType, filters?: any,) => {
    const history = useHistory();
    const [catalogData, setCatalogData] = useState<ItemType[]>([] as ItemType[]);
    const formattedData = useMemo(() => formatData(catalogData), [catalogData]);

    const getData = useCallback(async () => {
        const data = {
            catalog: {
                id: catalog
            }
        };
        const pos = getPosition();
        const response = await API.service('getCatalog', data, pos, callbackChangeAlert, null, history);
        setCatalogData(response?.data?.data?.catalog)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [catalog])

    useEffect(() => {
        getData()
    }, [getData])

    return [formattedData]

}